export const packages = {
  trademark: [
    {
      name: 'Basic',
      price: 45,
      features: [
        'Case Review',
        'Case Filing',
        'Basic Search',
        'State E-Filing',
        'Trademark Secured'
      ],
      featured: false
    },
    {
      name: 'Standard',
      price: 149,
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured',
        'High Satisfaction Rate',
        'Refusal Risk Meter'
      ],
      featured: false
    },
    {
      name: 'Deluxe',
      price: 299,
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured',
        'High Satisfaction Rate',
        'Refusal Risk Meter',
        'Trademark Monitoring',
        'Complete Documentation',
        'Digital File',
        'Dedicated Case Manager'
      ],
      featured: true
    },
    {
      name: 'Platinum',
      price: 349,
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured',
        'High Satisfaction Rate',
        'Refusal Risk Meter',
        'Trademark Monitoring',
        'Complete Documentation',
        'Digital File',
        'Dedicated Case Manager',
        'High Approval Rate',
        'Comprehensive Trademark Search Report (Federal & State)',
        'High Priority Service',
        'Cease & Desist Letter'
      ],
      featured: false
    }
  ],
  copyright: [
    {
      name: 'Gold',
      price: 99,
      features: [
        'Professional Preparation of your federal copyright application',
        'Federal E-Filing with USPTO',
        'Certificate of Registration mailed directly to you'
      ]
    },
    {
      name: 'Diamond',
      price: 149,
      features: [
        'Cease & Desist Letter template',
        'Transfer/Assignment custom template',
        '24 Hours Expedited Processing',
        'All features from Gold package'
      ]
    }
  ],
  search: [
    {
      name: 'Federal & State Search',
      price: 149,
      features: [
        'Federal trademark search with USPTO',
        'State search across all 50 states',
        'Detailed online report with matches'
      ]
    },
    {
      name: 'Federal, State & Common Law',
      price: 299,
      features: [
        'All features from Federal & State Search',
        'Corporate name search in all 50 states',
        'Corporate directory searches',
        'Common law proprietary internet searches',
        'Domain name searches'
      ]
    },
    {
      name: 'Global Search',
      price: 499,
      features: [
        'Global pending and registered marks search',
        'European community search',
        'WIPO (World Intellectual Property Organization) search',
        'Multi-national jurisdiction coverage'
      ]
    }
  ],
  amazon: [
    {
      name: 'Standard',
      price: 99,
      features: [
        'Amazon Brand Case Review',
        'Amazon Brand Case Filing',
        'High Satisfaction Rate'
      ]
    },
    {
      name: 'Diamond',
      price: 149,
      features: [
        'Amazon Brand Case Review',
        'Amazon Brand Case Preparation',
        'Amazon Brand Case Filing',
        'High Satisfaction Rate',
        'Refusal Risk Meter'
      ]
    },
    {
      name: 'Premium',
      price: 199,
      features: [
        'Amazon Brand Case Review',
        'Amazon Brand Case Preparation',
        'Amazon Brand Case Filing',
        'High Satisfaction Rate',
        'Refusal Risk Meter',
        'Amazon Brand Case Monitoring',
        'Complete Documentation',
        'Digital File',
        'Dedicated Case Manager'
      ]
    }
  ]
};

export const services = [
  {
    title: 'Trademark Registration',
    description: 'Protect your brand name, logo, or slogan with fast and reliable trademark registration consultancy.',
    icon: 'FileText'
  },
  {
    title: 'Copyright Registration',
    description: 'Secure your creative works with our expert copyright registration services.',
    icon: 'Copyright'
  },
  {
    title: 'Company Formation',
    description: 'Start your business the right way with professional LLC or Corporation setup.',
    icon: 'Building2'
  },
  {
    title: 'Amazon Brand Registry',
    description: 'Get verified on Amazon and safeguard your products with ease.',
    icon: 'ShoppingBag'
  },
  {
    title: 'Trademark Search',
    description: 'Avoid conflicts and ensure your trademark is unique with our thorough search services.',
    icon: 'Search'
  }
];

export const features = [
  {
    title: 'Availability',
    description: 'Our team is available 24/7 to assist you. We ensure a smooth experience and provide support at every step of your trademark journey.',
    icon: 'Clock'
  },
  {
    title: 'Accuracy',
    description: 'We deliver precise services each time. Our experts review submissions to ensure compliance and avoid any delays.',
    icon: 'Target'
  },
  {
    title: 'Approval',
    description: 'Our strategies maximize the chances of fast trademark approval. We guide you through the process to ensure a successful outcome.',
    icon: 'CheckCircle2'
  },
  {
    title: 'Reviews',
    description: 'Clients consistently praise our reliability and efficiency. We take pride in delivering excellent service that earns customer trust.',
    icon: 'Star'
  }
];

export const testimonials = [
  {
    name: 'Maria Sanchez',
    text: 'The team at Global Trademark USA was amazing. They answered all my questions and ensured that my trademark was filed without any hassle. I felt confident and supported throughout the entire process!'
  },
  {
    name: 'Ethan Knight',
    text: 'I was really impressed by the seamless service from Global Trademark USA. They made registering my trademark straightforward and stress-free, with constant updates and quick responses to any of my concerns.'
  },
  {
    name: 'Laura Bennett',
    text: 'Exceptional experience! Global Trademark USA handled everything with great expertise and professionalism. I was kept informed throughout the process and felt confident knowing my brand was in good hands.'
  },
  {
    name: 'Jessica Martinez',
    text: 'I had such a positive experience with Global Trademark USA. They guided me through every step of the trademark process, making it easy and stress-free. Highly recommend them for anyone looking to protect their brand!'
  },
  {
    name: 'David Lawrence',
    text: 'Global Trademark USA was incredibly professional and efficient. The team made sure I understood the entire process and handled all the details quickly. I couldn\'t be happier with their service and attention to detail.'
  }
];

export const faqs = [
  {
    question: 'What is a trademark and why is it important?',
    answer: 'A trademark is a legally registered name, logo, or slogan that distinguishes your goods or services from others. At Global Trademark USA, we help secure your brand, giving you exclusive rights and protection.'
  },
  {
    question: 'How much does it cost to register a trademark?',
    answer: 'Costs can vary depending on your needs, but at Global Trademark USA, we offer transparent pricing and flexible service options to fit your budget.'
  },
  {
    question: 'Can I trademark a business name that\'s already in use?',
    answer: 'No, a trademark can only be registered if it\'s not already in use for similar goods or services. Global Trademark USA performs comprehensive searches to ensure your name is unique before filing.'
  },
  {
    question: 'What happens if my trademark application is denied?',
    answer: 'If denied, Global Trademark USA will guide you through the appeal process and help resolve any issues, ensuring the best chance for approval.'
  },
  {
    question: 'Do I need a trademark if I have a registered business name?',
    answer: 'Yes, registering a business name doesn\'t provide trademark protection. A trademark through Global Trademark USA protects your brand identity in the marketplace, preventing others from using it.'
  },
  {
    question: 'Do I need an attorney to register a trademark?',
    answer: 'While not mandatory, working with an experienced trademark attorney significantly reduces errors and increases your chances of approval.'
  },
  {
    question: 'What if a similar trademark already exists? Can I still register mine?',
    answer: 'It depends on the similarity and the goods or services provided. A professional evaluation can help determine your eligibility and minimize risks.'
  },
  {
    question: 'Should I register my business name and logo separately?',
    answer: 'Yes, to ensure full protection, both should be registered separately. This allows for more comprehensive brand security.'
  },
  {
    question: 'How many trademark classes should I register under?',
    answer: 'You should file under every class relevant to your goods and services. Choosing the right classes is crucial for effective protection.'
  },
  {
    question: 'Can I use the ™ symbol before registering my trademark?',
    answer: 'Yes, the ™ symbol can be used to signify an unregistered trademark. The ® symbol, however, is reserved for federally registered trademarks.'
  }
];

export const benefits = [
  {
    title: 'Legal Protection',
    description: 'Secures exclusive rights to use your brand name, logo, or slogan.',
    icon: 'Shield'
  },
  {
    title: 'Brand Identity',
    description: 'Helps distinguish your products or services from competitors.',
    icon: 'Badge'
  },
  {
    title: 'Nationwide Coverage',
    description: 'Provides protection across the entire country, not just in one area.',
    icon: 'Globe'
  },
  {
    title: 'Increased Credibility',
    description: 'Boosts your brand\'s professional image and trustworthiness.',
    icon: 'Award'
  },
  {
    title: 'Ability to Sue',
    description: 'Gives you the legal standing to take action against infringement.',
    icon: 'Scale'
  },
  {
    title: 'Asset Value',
    description: 'Trademarks can become valuable assets that can be licensed or sold.',
    icon: 'TrendingUp'
  }
];

export const canTrademark = [
  'Business names and unique brand names',
  'Logos, symbols, or unique brand designs',
  'Slogans like "Think Different"',
  'Product or service names',
  'Unique packaging or brand trade dress',
  'Brand mascots or characters'
];

export const cannotTrademark = [
  'Common or generic terms (e.g., "Coffee")',
  'Functional designs or product features (patent-eligible)',
  'Concepts or abstract ideas (only expressions are protected)',
  'Original works like songs or films (protected by copyright)',
  'Geographic names lacking distinctiveness',
  'Offensive or misleading trademarks'
];

export const comparisonData = [
  { feature: 'Expert Trademark Filing Help', us: true, competitors: false },
  { feature: 'Custom Legal Strategy', us: true, competitors: false },
  { feature: 'Real-Time Application Updates', us: true, competitors: false },
  { feature: 'In-Depth Trademark Search', us: true, competitors: true },
  { feature: 'Comprehensive Brand Protection', us: true, competitors: false },
  { feature: 'Dedicated Customer Support', us: true, competitors: false },
  { feature: 'Affordable, Transparent Fees', us: true, competitors: false },
  { feature: 'High Approval Success Rate', us: true, competitors: true },
  { feature: 'Ongoing Post-Registration Support', us: true, competitors: false }
];

export const steps = [
  {
    number: 1,
    title: 'Submit Your Details',
    description: 'Easily provide your trademark details—name, logo, or slogan—through our simple process. We ensure a quick and accurate registration start.'
  },
  {
    number: 2,
    title: 'Select Your Service and Complete Payment',
    description: 'Choose the right registration package for your business. With clear pricing and secure payment, the process is both simple and reliable.'
  },
  {
    number: 3,
    title: 'Expert Evaluation and Filing',
    description: 'Our team thoroughly reviews your trademark to meet legal standards. We help with the filing process with precision, maximizing your approval chances.'
  }
];

export const achievements = [
  { title: 'Expert Guidance', icon: 'Award' },
  { title: 'Successful Registrations', icon: 'TrendingUp' },
  { title: 'Brand Protection', icon: 'Shield' },
  { title: 'Proven Results', icon: 'Star' }
];